import type { RatingContext } from '@risksmart-app/components/src/hooks/useRating';

import type { AssessmentTypeEnum } from './types';

export const getRatingContext = (
  assessmentMode?: AssessmentTypeEnum
): RatingContext | undefined =>
  assessmentMode === 'internal_audit_report'
    ? 'internal_audit'
    : assessmentMode === 'compliance_monitoring_assessment'
      ? 'oversight'
      : undefined;
